export const JAMF_FAQ_URL =
  'https://faq.allwhere.co/en_us/jamf-beta-test-set-up-B1s55NMckx';
